// @flow
import React, { Component } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import Actions from "../../../../actions/units";
import { Spin } from "antd";
import Form from "./Form";

class Unit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isNew: false
    };
  }

  componentWillMount = () => {
    if (this.props.match.params.id) {
      this.props.dispatch(
        Actions.fetchUnit(this.props.match.params.id)
      );
    } else {
      this.setState({ isNew: true }, () => {
        this.props.dispatch(Actions.onNew());
      });
    }
  };

  onSave = () => {
    if (this.props.match.params.id) {
      this.props.dispatch(Actions.onUpdate(this.props.match.params.id));
    } else {
      this.props.dispatch(Actions.onCreate()).then(() => {
        if (!this.props.errors) {
          this.props.history.push(
            `/references/units/${this.props.unit.id}/edit`
          );
        }
      });
    }
  };

  onClose = () => {
    this.props.history.push(`/references/units`);
  };

  onChangeCode = e => {
    this.props.dispatch(Actions.onChangeCode(e.target.value));
  };

  onChangeName = e => {
    this.props.dispatch(Actions.onChangeName(e.target.value));
  };



  render() {
    const { isLoading, unit } = this.props;
    return isLoading ? (
      <Spin />
    ) : (
        <Form
          isNew={this.state.isNew}
          unit={unit}
          onSave={this.onSave}
          onClose={this.onClose}
          onChangeCode={this.onChangeCode}
          onChangeName={this.onChangeName}
        />
      );
  }
}

Unit.propTypes = {
  dispatch: PropTypes.func,
  match: PropTypes.object,
  unit: PropTypes.object,
  isLoading: PropTypes.bool,
  errors: PropTypes.bool
};

const mapStateToProps = state => ({
  isLoading: state.units.isLoading,
  errors: state.units.errors,
  unit: state.units.unit
});

export default connect(mapStateToProps)(withRouter(Unit));
